'use strict';

import BookerTracker from "../../../MetricsTracker/booker/metrics";
import { getHeaders } from "./tokenUtil";

export default class CalendarAvailabilityService {
    constructor() {
        this.config = window.__pt.settings.site;
        this.exchange = window.__pt.exchange;
        this.params = window.__pt.box;
        this.fn = window.__pt.fn;
        this.language = window.__pt.ln;
        this.memory = {};
        this.mainElement = null;
        this.eventHandler = new BookerTracker();
    }

    async getAvailability(hotelId, year, month, isAccommodation = false, isPackage = false) {
        let params = this.getParams(hotelId, year, month, isPackage);
        let query = this.fn.objectToQueryParams(params);
        let key = `${hotelId}_${year}_${month}`

        if (!this.memory[key]) {

            let headers = getHeaders();

            let response = await fetch(`${isAccommodation ? this.config.endPoints.calendarAvailabilityAccommodationUrl : this.config.endPoints.calendarAvailabilityUrl}?${query}`, { method: 'GET', headers: headers }).then(response => response.json()).catch((err) => console.log("error quote availability:", err.message));
            if (response) {
                this.memory[key] = response;
                this.eventHandler.availabilityCalendar(response.events || []);
            }
        }

        return this.memory[key];
    }

    async getPriceRangeCalendar(origin, destination, year, month, tripMode) {
        let params = this.getFlightParams(year, month, {
            origin,
            destination,
            tripMode
        });
        let query = this.fn.objectToQueryParams(params);
        let routeKey = `flight_${origin}_${destination}_${tripMode}`;
        let dateKey = `${year}_${month}`;
        if (!this.memory[routeKey]?.[dateKey]) {
            let headers = getHeaders();
            const endpoint = this.config.endPoints.priceRangeCalendarBookerUrl;
            let response = await fetch(`${endpoint}?${query}`, { method: 'GET', headers: headers }).then(response => response.json()).catch((err) => console.log("error quote calendar:", err.message));
            if (response) {
                this.memory[routeKey] = {
                    ...this.memory[routeKey],
                    [dateKey]: response,
                };
            }
        }
        return { getDataCalendar: this.memory[routeKey]?.[dateKey], keys: Object.keys(this.memory) }
    }

    build(elements, response = {}) {

        if (response && response.daysByDate) {
            let days = response.daysByDate || {};

            for (let dayKey in days) {
                const day = days[dayKey];

                let element = elements[day.checkinFormat];
                this.buildElement(element, day)
            }

            this.footerBuild();
        }

    }

    buildElement(element, day) {
        if (element) {
            let rounded = 0;
            let span = element.target.querySelector('.day-price') || document.createElement('span');
            span.className = day.available ? 'day-price available' : 'day-price unavailable';

            rounded = this.roundNumber(day.avgPrice);

            span.innerHTML = day.available ? `${rounded}` : `  `;
            element.target.append(span);
            if (day.color && day.color.length) {
                element.target.classList.add(day.color);
            }
        }
    }

    roundNumber(val) {

        const currency = __pt.settings.site.currency;
        if (currency === 'COP') {
            const suffix = val.slice(-1);
            let number = parseFloat(val.slice(0, -1));
            return `${this.customRound(number)}${suffix}`;
        } else if (currency !== 'COP' && (val.endsWith('K') || val.endsWith('M'))) {
            return val;
        } else {
            return this.customRound(val);
        }
    }

    customRound(num) {
        const decimal = num % 1;
        const integer = Math.floor(num);

        if (decimal > 0.5) {
            return integer + 1;
        } else {
            return num;
        }
    }


    setFooterElement(element) {
        this.mainElement = element;
    }

    footerBuild() {
        if (this.mainElement && Object.keys(this.memory).length) {
            let footerContainer = this.mainElement.querySelector('.calendarfooter') || document.createElement('div');
            footerContainer.className = 'calendarfooter';

            footerContainer.innerHTML = `
                <div class="calendarfooter__legend">
                    <span class="legend__lowp"><div></div>${this.language.low_prices}</span>
                    <span class="legend__lowerp"><div></div>${this.language.lower_prices}</span>
                </div>
                <span class="calendarfooter__price">
                    ${this.language.price_calendar_footer.replace("{currency}", this.config.currency)}
                </span>
            `;

            this.mainElement.append(footerContainer);
        }
    }


    getMemoryDate(key, keyDate, hotelId) {
        if (hotelId) {
            key = `${hotelId}_${key}`;
            return this.memory[key] && this.memory[key].daysByDate ? this.memory[key].daysByDate[keyDate] : null;
        }
    }

    overFlow() {
        if (this.config.mobile) {
            let body = document.body;
            body.classList.toggle('modal-open');

            let div = document.querySelector('.modal-backdrop.fade.show.modal-backdrop-custom');

            if (div) {
                div.remove()
            } else {
                div = document.createElement('div');
                div.className = 'modal-backdrop fade show modal-backdrop-custom';
                document.body.append(div);
            }

        }
    }

    setCalendarPriceContainer() {
        if (this.mainElement) {
            let parent = this.mainElement.parentElement;
            parent.classList.add('container-price')
        }
    }

    removeCalendarPriceContainer() {
        if (this.mainElement) {
            let parent = this.mainElement.parentElement;
            parent.classList.remove('container-price')
        }
    }

    getParams(hotelId, year, month, isPackage = false) {
        return {
            site: this.config.domain.replace("https://", ""),
            mobile: this.config.mobile,
            propertyId: hotelId,
            year: year,
            month: month,
            currency: this.exchange.currency,
            type: 'json',
            ...(isPackage ? { isPackage: true } : {})
        }
    }

    getFlightParams(year, month, options) {
        return {
            site: this.config?.siteCode ?? this.config.code,
            mobile: this.config.mobile,
            type: 'json',
            origin: options.origin,
            destination: options.destination,
            tripMode: options.tripMode,
            year: year,
            month: month,
            currency: this.exchange.currency,
        };
    }
}

export const CalendarAvailability = new CalendarAvailabilityService();
